 
           
export function createXLSheetdata(kitchenList) {
    kitchenList.find((ticketDetails, index) => {
                
            kitchenList[index].kitchenStaffId=kitchenList[index].id
            delete kitchenList[index]['id']
                
            kitchenList[index].EmployeeCode=kitchenList[index].employee_id
            delete kitchenList[index]['employee_id']

            kitchenList[index].EmployeeName=kitchenList[index].employee_name
            delete kitchenList[index]['employee_name']
            
            kitchenList[index].EmployeeMobile=kitchenList[index].employee_mobile
            delete kitchenList[index]['employee_mobile']
            
            kitchenList[index].employeeDesignation=kitchenList[index].employee_designation
            delete kitchenList[index]['employee_designation']
            
            kitchenList[index].WorkStation=kitchenList[index].work_station
            delete kitchenList[index]['work_station']
            
            kitchenList[index].KitchenName=kitchenList[index].kitchen_name
            delete kitchenList[index]['kitchen_name']
            
            kitchenList[index].KitchenCode=kitchenList[index].kitchen_code
            delete kitchenList[index]['kitchen_code']
            
            kitchenList[index].Cluster=kitchenList[index].cluster
            delete kitchenList[index]['cluster']
            
            kitchenList[index].ClusterManager=kitchenList[index].cluster_manager
            delete kitchenList[index]['cluster_manager']

            kitchenList[index].KitchenManager=kitchenList[index].kitchen_manager
            delete kitchenList[index]['kitchen_manager']

            kitchenList[index].City=kitchenList[index].city_name
            delete kitchenList[index]['city_name']

            if(kitchenList[index].moving){
                kitchenList[index].Movement="IN TRANSIT"
            }else{
                 kitchenList[index].Movement=""
            }
                   
            delete kitchenList[index]['moving']  
            delete kitchenList[index]['employee_pk_id']  
            delete kitchenList[index]['kitchen_movement']            
            return false

            })   
            return kitchenList
}



// WEBPACK FOOTER //
// ./src/modules/Kitchen Staffs/services/helpers.js